import { useMemo } from 'react';
import { NextPage } from 'next';
import { useRouter } from 'next/router';

import { PageSection } from 'types/pages';
import { Routes } from 'types/routes';

import { withVariables } from 'utils/string';

import Head from 'components/layout/Head';
import PageContainer from 'components/layout/PageContainer';
import SectionsWrapper from 'components/layout/SectionsWrapper';
import WrapperPublic from 'components/wrappers/Public';

import SectionArticle from './sections/Article';
import SectionArticles from './sections/Articles';
import SectionNewsletter from './sections/Newsletter';
import StyledComponent from './styles';
import { Props } from './types';

const PageArticle: NextPage<Props> = ({ pageTranslations, articles, article }) => {
    const router = useRouter();
    const sections: PageSection[] = useMemo(() => [{
        slug: 'article',
        order: 1,
        isVisible: true,
        children: (slug, translations) => (
            <SectionArticle
                key={slug}
                article={article}
                translations={translations}
            />
        ),
    }, {
        slug: 'articles',
        order: 2,
        isVisible: true,
        children: (slug, translations) => (
            <SectionArticles
                key={slug}
                articles={articles}
                translations={translations}
            />
        ),
    }, {
        slug: 'newsletter',
        order: 3,
        isVisible: true,
        children: (slug, translations) => (
            <SectionNewsletter
                key={slug}
                translations={translations}
            />
        ),
    }], [router.asPath]);

    return (
        <WrapperPublic>
            <StyledComponent className="page-article">
                <Head
                    title={pageTranslations?.page?.metaTitle}
                    description={pageTranslations?.page?.metaDescription}
                    canonical={withVariables(Routes.PublicArticles)}
                />
                <PageContainer>
                    <SectionsWrapper
                        memoParams={[router.asPath]}
                        sections={sections}
                        localTranslations={pageTranslations?.sections}
                        enabledStates={pageTranslations?.sectionsEnabled}
                    />
                </PageContainer>
            </StyledComponent>
        </WrapperPublic>
    );
};

export default PageArticle;
